export enum ThemeSelector {
  SANDOZ_LIGHT = 'sandoz-light',
  SANDOZ_DARK = 'sandoz-dark',
}

export type ThemeSelectors = `${ThemeSelector}`;
